import PropTypes from "prop-types";
import Mobile from "./mobile";
import Desktop from "./desktop";

const SearchQuick = ({ isMobile, ...restProps }) => {

	if (isMobile) {

		return <Mobile {...restProps} />;

	}

	return <Desktop {...restProps} />;

};

SearchQuick.propTypes = {
	isMobile: PropTypes.bool,
};

SearchQuick.defaultProps = {
	isMobile: false,
};

export default SearchQuick;
